/**
 * ID card number can be in string or number format depending on whether it is EXT or CI / RUC type.
 * Only for EXT type, it can be alphanumeric.
 * @param dni
 * @returns
 */

export const documentNumberFormat = (dni: number | string): string => {
  const regex = /[a-zA-ZñÑ]/;

  return typeof dni === 'number'
    ? dni.toLocaleString().replace(/,/g, '.')
    : regex.test(dni)
    ? dni
    : Number(dni).toLocaleString().replace(/,/g, '.');
};

export const formatRuc = (ruc: string): string =>
  [
    ruc.slice(0, ruc.length - 1),
    '-',
    ruc.slice(ruc.length - 1, ruc.length),
  ].join('');

export const isCompanyRuc = (ruc: string | number): boolean => {
  if (!ruc) return false;
  const toStringRuc = ruc.toString();
  const slicedRuc = toStringRuc.slice(0, toStringRuc.length - 1);
  return Number(slicedRuc) >= 80000000;
};

export const isRuc = (value: string): boolean => value === 'RUC';

export const isExt = (value: string): boolean => value === 'EXT';

export const isCI = (value: string): boolean => value === 'CI';
